<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <user-form />
  </v-container>
</template>

<script>
import UserForm from './_Form'

export default {
  name: 'AdminTopicNew',
  components: {
    UserForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'トピック一覧', disabled: false, to: { name: 'AdminTopics' }, exact: true },
        { text: 'トピックー追加', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>
